<app-page-layout 
  [title]="title"
  [subtitle]="subtitle"
  [heroImage]="heroImage"
  [breadcrumbs]="breadcrumbs"
  [prevPage]="prevPage"
  [nextPage]="nextPage"
  [partners]="partners">

  <!-- Main Title Section -->
  <div class="page-title-section">
    <h2>Assurance Voyage Personnel</h2>
  </div>

  <!-- Main Content -->
  <div class="content-section main-content">
    <h3 class="section-heading purple-text">PARTEZ EN VOYAGE L'ESPRIT LÉGER ET RASSURÉ !</h3>
    
    <p>
      Vous habitez en France ou dans l'Union Européenne, vous avez moins de 80 ans, et vous souhaitez voyager à l'étranger, vous avez donc besoin d'une assurance voyage personnel. Cette assurance sera d'autant plus importante que la durée du séjour est longue. Ceux qui partent pour des séjours cours ont un besoin de protection contre les risques « d'urgence » (accident, maladie, rapatriement…).
    </p>
    
    <p>
      Ceux qui partent pour un séjour plus long ont quant à eux, droit à une couverture plus complète et « quotidienne », relative à leur "nouvelle" vie sur place.
    </p>

    <p>
      La différenciation repose sur le critère de la durée de votre présence hors France :
    </p>
    
    <ul class="main-list">
      <li>Si vous partez moins de <strong class="highlight-purple">90 jours consécutifs</strong> et au total, moins de <strong class="highlight-purple">180 jours par an</strong>, vous aurez besoin d'une couverture simple,</li>
      <li>Si vous partez plus de <strong class="highlight-purple">180 jours consécutifs</strong> ou pour une installation permanente (sans date de retour fixée), vous aurez besoin d'une couverture plus solide notamment avec prise en charge des frais de santé. En effet, vos droits à la sécurité sociale s'arrêtent au bout de 90 jours. Il est donc nécessaire de souscrire une assurance dite <strong class="text-purple">Assurance Mutuelle Santé Internationale</strong>.</li>
    </ul>

    <p>
      Le <strong class="text-purple">courtier en Assurance BROKINS</strong> est partenaire de nombreux assureurs, dont un échantillon est affiché ci-dessous : <strong class="text-purple">GENERALI, APRIL, SWISSLIFE, ALPTIS, HENNER, CHAPKA…</strong>
    </p>
    
    <!-- Devis Button -->
    <div class="devis-button-wrapper">
      <button class="btn-devis" (click)="navigateToComparison()">
        Devis en ligne
      </button>
    </div>
  </div>

  <!-- Additional Sections -->
  <div class="content-section additional-info">
    <h3 class="section-heading">Dans tous les cas, il existe deux formules possibles quelque soit la durée du séjour :</h3>
    
    <div class="formules-section">
      <h4>Garantie Annulation pour toutes causes justifiées :</h4>
      <ul>
        <li>Annulation du voyage,</li>
        <li>Vol manqué.</li>
      </ul>
      
      <h4>Garantie Multirisque pour assurer aussi les frais de santé, perte de vos bagages, attestation pour le visa :</h4>
      <ul>
        <li>Annulation du voyage,</li>
        <li>Vol manqué,</li>
        <li>Retard aérien > 4 heures,</li>
        <li>Bagages et effets personnels,</li>
        <li>Frais d'interruption de séjour,</li>
        <li>Individuelle accident voyage,</li>
        <li>Responsabilité civile vie privée à l'étranger,</li>
        <li>Retour impossible,</li>
        <li>Assistance rapatriement (avec avance sur les frais de santé),</li>
        <li>Retour anticipé,</li>
        <li>Assistance voyage.</li>
      </ul>
    </div>

    <p>
      Et pour les sportifs, possibilité d'une extension des frais de recherche et de secours en mer et en montagne.
    </p>

    <h3 class="section-heading purple-text">RASSUREZ-VOUS, AFIN QUE VOUS PARTIEZ EN TOUTE CONFIANCE !</h3>
    
    <p>
      Vous faites partie des <strong class="highlight-purple">60 % des Français</strong> qui partent en vacances. Mais ne faites pas partie des <strong class="highlight-purple">25 %</strong> qui ne souscrivent pas à une assurance voyage !
    </p>

    <p>
      La plupart des Français ne savent pas qu'ils peuvent être assurés en cas d'annulation de leur prestation ou en cas d'accident sur place. Or, cela arrive plus souvent qu'on ne le croit.
    </p>
    
    <p>
      A chaque besoin une formule d'assurance vous correspond, il vous suffit de vous poser les bonnes questions :
    </p>
    
    <ul class="questions-list">
      <li>Avez-vous besoin d'une attestation pour la Russie ?</li>
      <li>Quels sont les montants des frais médicaux conseillés pour partir aux Etats Unis ou en Asie ?</li>
      <li>Et si vous manquez votre vol ?</li>
      <li>Etes-vous assuré en cas d'accident durant une compétition sportive ?</li>
    </ul>

    <p class="warning-text">
      <strong>Attention :</strong> L'assurance comprise dans votre Carte Bancaire ne suffit pas toujours à être bien assuré Exemple : Avec votre CB, autant vous pouvez garantir l'annulation du Vol allée, autant le vol retour n'est jamais pris en charge.
    </p>

    <h3 class="section-heading purple-text">LES PLUS DE CETTE ASSURANCE :</h3>
    
    <ul class="benefits-list">
      <li>Annulation pour toutes causes justifiées,</li>
      <li>Annulation en cas d'attentat ou de catastrophe naturelle,</li>
      <li>Avion manqué,</li>
      <li>Garantie Retour impossible incluse,</li>
      <li>Une couverture étendue et adaptée pour les déplacements sportifs ou à thème,</li>
      <li>La possibilité de mettre jusqu'à 9 personnes par contrat.</li>
    </ul>

    <h3 class="section-heading">LES TARIFS :</h3>
    
    <p>
      Il dépendent tout simplement du prix TTC moyen du voyage. Cela peut représenter quelques euros pour des garanties atteignant plusieurs milliers d'euros.
    </p>

    <h3 class="section-heading purple-text">IMPORTANT !</h3>
    
    <ul class="important-list">
      <li>Le contrat doit être souscrit au plus tard la veille du départ,</li>
      <li>L'extension Sports et Loisirs doit être souscrite simultanément à la Multirisque,</li>
      <li>Sur un même contrat, tous les assurés doivent avoir souscrit la même formule,</li>
      <li>Visa : Pour les voyages en Russie, Biélorussie et Ukraine, une attestation d'assurance originale est nécessaire pour l'obtention du visa.</li>
      <li>Si votre voyage se fait dans le cadre de votre activité professionnelle, appelé déplacement professionnel, alors il est sans doute plus opportun de souscrire à une <a routerLink="/cac/particuliers/assurance-voyage-professionnel" class="link-purple">Assurance Voyage Professionnel</a>.</li>
    </ul>
  </div>

</app-page-layout>

